<section class="branch-register">
  <div class="branch-container">
    <span style="color: #ff6600; font-weight: bold; font-size: 24px"
      >{{ isEdit ? 'Editar sucursal' : 'Agregá una sucursal' }}
    </span>
    <form class="branch-form" [formGroup]="form" (ngSubmit)="onSubmitEventHandler(form.value)" autocomplete="off">
      <mat-form-field class="input-yaca w-100">
        <mat-label>Nombre</mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          (paste)="checkPaste($event)"
          (drop)="checkDrop($event)"
          (keypress)="checkPattern($event)"
          [placeholder]="translate('pages.branch_offices.messages.name_placeholder')"
          maxlength="100"
        />
        <mat-error *ngIf="true">{{ 'pages.branch_offices.messages.name_required' | translate }} </mat-error>
      </mat-form-field>
      <search-place-component
        style="width: 100%"
        tabindex="3"
        formControlName="address"
        (selectedEvent)="selectedPlaceEventHandler($event)"
      >
      </search-place-component>
      <mat-form-field class="input-yaca w-100">
        <mat-label>Télefono* - ejemplo: 11 1234 5678</mat-label>
        <input
          matInput
          type="text"
          [mask]="pixPhoneMaskSelected"
          inputmode="numeric"
          placeholder="{{ translate('pages.pix_pay.phone.label') }}"
          formControlName="phone"
        />
        <mat-hint> {{ pixPhoneHintSelected }}</mat-hint>
        <mat-error class="input-error" *ngIf="form.controls.phone.invalid">
          {{ translate('pages.pix_pay.phone.phone_error') }} {{ pixPhoneHintSelected }}
        </mat-error>
      </mat-form-field>
      <div class="buttons-container">
        <button mat-stroked-button class="w-button mr-3 button-back" type="button" (click)="goBack()">
          {{ 'commons.buttons.back' | translate }}
        </button>
        <button
          *ngIf="isEdit"
          mat-raised-button
          button="submit"
          tabindex="0"
          color="primary"
          style="width: 100px"
          [ngClass]="{ 'button-save': editado || saving }"
          [disabled]="!editado || saving"
        >
          {{ 'commons.buttons.save' | translate }}
        </button>

        <button
          *ngIf="!isEdit"
          mat-raised-button
          button="submit"
          tabindex="0"
          color="primary"
          style="width: 100px"
          [ngClass]="{ 'button-save': !form.invalid }"
          [disabled]="form.invalid || saving"
        >
          {{ 'commons.buttons.save' | translate }}
        </button>
      </div>
      <div *ngIf="saving" class="action-label">
        <span class="action-text">{{ 'pages.responsibles.labels.saving' | translate }}</span>
        <mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
      </div>
    </form>
  </div>
</section>
